import { render, staticRenderFns } from "./SubDivisionDelivered-Column.vue?vue&type=template&id=083dc65b&"
import script from "./SubDivisionDelivered-Column.vue?vue&type=script&lang=js&"
export * from "./SubDivisionDelivered-Column.vue?vue&type=script&lang=js&"
import style0 from "./SubDivisionDelivered-Column.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports